import { companySchema } from "@/schema/Company";
import { companyUserSchema } from "@/schema/CompanyUser";
import { appAssessmentProgressSchema } from "@/schema/AssessmentProgress";
import { z } from "zod";

export const companyDetailSchema = companySchema.extend({
  company_users: z.array(companyUserSchema),
  assessment_progresses: z.array(appAssessmentProgressSchema),
});

export type CompanyDetail = z.infer<typeof companyDetailSchema>;
